import { useState, useEffect } from 'react';

export function useQueryLifecycle(networkStatus: any) {
  const [startedFetch, setStartedFetch] = useState(false);
  const [isCached, setIsCached] = useState(true);

  useEffect(() => {
    if (networkStatus === 1) {
      setStartedFetch(true);
    }
    if (startedFetch && networkStatus === 7) {
      // This is when fresh data is received
      setIsCached(false);
    }
  }, [networkStatus, startedFetch]);

  return { isCached };
}
